<template>
  <div class="page-container" v-wechat-title="titleTop">
    <!-- 顶部状态栏占位 (保持原设计) -->
    <div class="status-bar-placeholder"></div>
    
    <!-- 列表区域 (含下拉刷新) -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="pull-content">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        class="list-container"
      >
        <!-- 空状态 -->
        <div v-if="!loading && list.length === 0" class="empty-box">
          <van-icon name="smile-o" size="40" />
          <p class="empty-text">暂无行程</p>
        </div>

        <!-- 分组渲染 -->
        <div v-for="(group, gIndex) in groupedList" :key="gIndex">
          
          <!-- 分组标题 -->
          <div class="group-header">
            <div class="header-dot"></div>
            <div class="header-text">
              <!-- 日期 -->
              {{ group.dateStr }}
              <!-- 目的地 (写死) -->
              <span class="header-dest">· 前往 {{group.items[0].typeName?group.items[0].typeName:'/'}}</span>
            </div>
          </div>

          <!-- 卡片列表 -->
          <div 
            v-for="item in group.items" 
            :key="item.studentId" 
            class="visual-card"
            @click="onTrip(item)"
          >
            <!-- 左侧：图片 (默认图方案) -->
            <div class="card-thumb">
              <img v-if="item.type==='SCHEDULING' && item.isLiveaboard" src="/img/backimg/trip1.jpg" class="thumb-img" alt="Trip" />
              <img v-if="item.type==='SCHEDULING' && !item.isLiveaboard" src="/img/backimg/trip2.jpg" class="thumb-img" alt="Trip" />
              <img v-if="item.type==='COURSE'" src="/img/backimg/trip3.jpg" class="thumb-img" alt="Trip" />
            </div>

            <!-- 右侧：信息区 -->
            <div class="card-info">
              <!-- A. 行程名称 -->
              <div class="trip-title">{{ item.title }}</div>
              
              <!-- B. 出行人 (写死) -->
              <div class="traveler-row">
                <van-icon name="manager-o" size="12" />
                <span>出行人: {{item.userName}}</span>
              </div>

              <!-- C. 状态 (右下角) -->
              <div class="card-bottom">
                <!-- 支付警告优先显示 -->
                <span v-if="item.isNeedOnlinePay" class="status-text st-red">
                  待支付尾款
                </span>
                <!-- 正常状态 -->
                <span v-else :class="['status-text', getStatusClass(item.state)]">
                  {{ GetEnumText('Em_LearningState', item.state) }}
                </span>
              </div>
            </div>
          </div>

        </div>
      </van-list>
    </van-pull-refresh>

    <!-- 隐性功能：关注公众号弹窗 -->
    <followWx v-model="showFollow" />
  </div>
</template>

<script>
import request from '@/utils/request'
import { Button, List, Tag, PullRefresh, Icon } from 'vant'
import { GetEnumText, formatDate, getUserBase, GetSysTitle } from '@/utils/base'
import followWx from '@/components/followWx'

export default {
  name: 'TripList',
  components: {
    [Button.name]: Button,
    [List.name]: List,
    [Tag.name]: Tag,
    [PullRefresh.name]: PullRefresh,
    [Icon.name]: Icon,
    followWx
  },
  data() {
    return {
      titleTop: '',
      title: '我的行程', // 仅用于 wechat-title，页面不显示
      
      // 列表状态
      loading: false,
      finished: false,
      refreshing: false,
      list: [], 
      search: {
        limit: 15,
        page: 1
      },

      // 业务组件
      showFollow: false,
      
    }
  },
  computed: {
    // 核心：数据分组逻辑
    groupedList() {
      const groups = {}
      this.list.forEach(item => {
        // 格式化日期作为 Key (例如 12月06日)
        const dateKey = this.formatDate(item.time, 'MM月dd日', true) || '待定日期'
        
        if (!groups[dateKey]) {
          groups[dateKey] = {
            dateStr: dateKey,
            destination: '精选目的地', // 后期手动修改处
            items: []
          }
        }
        groups[dateKey].items.push(item)
      })
      return Object.values(groups)
    }
  },

  created() {
    getUserBase(data => {
      this.titleTop = GetSysTitle()
      setTimeout(() => {
        this.showFollow = true
      }, 10)
    })
  },
  methods: {
    GetEnumText,
    formatDate,
    GetSysTitle,

    // --- 加载逻辑 ---
    onLoad() {
      if (this.refreshing) {
        this.list = []
        this.search.page = 1
        this.refreshing = false
      }

      request({
        url: '/DiveTrip/GetDiveTripList',
        method: 'post',
        data: this.search
      }).then(response => {
        this.loading = false
        if (!response.success) {
          this.finished = true
          return
        }
        
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        
        response.data.rows.forEach(item => {
          this.list.push(item)
        })
        
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      }).catch(() => {
        this.loading = false
        this.finished = true
      })
    },

    // --- 下拉刷新 ---
    onRefresh() {
      this.finished = false
      this.loading = true
      this.onLoad()
    },

    // --- 交互 ---
    onTrip(item) {
      this.$router.push('/divetrip/trip/' + item.studentId)
    },

    // --- 样式辅助 ---
    getStatusClass(state) {
      if (state === 0 || state === 'WAIT') return 'st-blue'
      if (state === 1 || state === 'DOING') return 'st-green'
      return 'st-gray'
    }
  }
}
</script>

<style scoped>
/* --- 全局基因 --- */
.page-container {
  min-height: 100vh;
  background-color: #F5F6FA; /* 淡灰背景 */
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", Helvetica, sans-serif;
  color: #333;
  padding-bottom: 40px;
}

.status-bar-placeholder { height: 10px; }

.list-container { padding: 0 16px 20px 16px; }
.pull-content { min-height: 80vh; }

/* --- 1. 分组标题 --- */
.group-header {
  display: flex;
  align-items: center;
  padding: 20px 4px 10px 4px;
}

.header-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: white;
  border: 2px solid #0057FF;
  margin-right: 10px;
  flex-shrink: 0;
  box-shadow: 0 0 0 2px rgba(0, 87, 255, 0.1);
}

.header-text {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  display: flex;
  align-items: center;
  gap: 6px;
}

.header-dest {
  font-weight: 400;
  color: #6B7280;
  font-size: 14px;
}

/* --- 2. 图文卡片 --- */
.visual-card {
  background: white;
  border-radius: 12px;
  padding: 12px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.03);
  margin-bottom: 8px;
  display: flex;
  gap: 12px;
  position: relative;
  transition: transform 0.2s;
}
.visual-card:active { transform: scale(0.98); }

/* 左侧图片 */
.card-thumb {
  width: 100px;
  height: 75px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  background-color: #F3F4F6;
  position: relative;
}
.thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 右侧信息 */
.card-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.trip-title {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-bottom: 4px;
}

.traveler-row {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #6B7280;
  background: #F9FAFB;
  width: fit-content;
  padding: 2px 8px 2px 6px;
  border-radius: 4px;
}

.card-bottom {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 4px;
}

.status-text {
  font-size: 12px;
  font-weight: 500;
}
.st-blue { color: #0057FF; }
.st-green { color: #059669; }
.st-gray { color: #9CA3AF; }
.st-red { color: #EF4444; font-weight: 700; } /* 支付警告 */

/* 空状态 */
.empty-box {
  text-align: center;
  padding-top: 80px;
  color: #9CA3AF;
}
.empty-text { font-size: 14px; margin-top: 10px; }
</style>